import apiCall from "../../api/crentAPI";
import store from "@/store";

const ENV =
    process.env.NODE_ENV === "staging" || process.env.NODE_ENV === "development"
        ? "ORM_" + process.env.VUE_APP_CUSTOMER_NAME + "_"
        : "ORM_";

/* eslint-disable */

const state = () => ({
  countries: [],
  origins: [],
  salutations: JSON.parse(sessionStorage.getItem(ENV + "selectedSalutations")) || [],
  mandatoryFields: JSON.parse(sessionStorage.getItem(ENV + "mandatoryFields")) || [],
  customer: {
    customer: {
      salutation_id: "",
      email: "",
      firstname: "",
      lastname: "",
      company_name: "",
      street: "",
      zipcode: "",
      city: "",
      country_id: "",
      phone_number: "",
      allow_marketing: false,
      create_login: false,
      mandatory_fields: {},
    },
    payment_method_id: "",
    remarks: "",
  },
});
/* eslint-enable */
const getters = {
  GET_COUNTRIES: (state) => state.countries || null,
  GET_ORIGINS: (state) => state.origins || null,
  GET_ORIGIN: (state) => (originName) => {
    return state.origins.find((origin) => origin.origin === originName);
  },
  GET_COUNTRY: (state) => (lang) => {
    return state.countries.find((countrie) => countrie.sign === lang);
  },
  /*GET_COUNTRY_BY_ID: (state) => (id) => {
    return state.countries.find((countrie) => countrie.id === id);
  },*/
  GET_COUNTRY_BY_ID: (state) => (id) => {
    const numericId = parseInt(id, 10);
    console.log(`Suche nach ID: ${id} (als Zahl: ${numericId})`);
    return state.countries.find((countrie) => countrie.id === numericId);
  },
  GET_SALUTATIONS: (state) => state.salutations || null,
  GET_SALUTATION: (state) => (id) => {
    if (state.salutations.length > 0 && id !== null && id !== "") {
      return state.salutations.find(
          (salutation) => salutation.id === parseInt(id)
      ).salutation;
    } else {
      return null;
    }
  },
  GET_CUSTOMER: (state) =>
      JSON.parse(sessionStorage.getItem(ENV + "selectedCustomer")) ||
      JSON.parse(JSON.stringify(state.customer)),
  GET_MANDATORY_FIELDS: (state) => state.mandatoryFields,
};
// actions
const actions = {
  async GET_MANDATORY_FIELDS({ commit }) {
    let response = [];
    await apiCall.getHeaders("/api/rent/customers/mandatory-fields", "", (result) => {
      if (result.status === 200) {
        response = result.data;
        commit("MUTATE_MANDATORY_FIELDS", result.data);
      } else if (result.status === 204) {
        commit("MUTATE_MANDATORY_FIELDS", []);
      }
    });
    return response;
  },
  async SET_ORIGINS({ commit }) {
    let status = false;
    await apiCall.get("/api/rent/customers/origins", "", (result) => {
      if (result.error || result.errorCode) {
        status = false;
        return ["ORMgeneral/SET_ORIGINS", status];
      } else {
        status = true;
      }
      commit("MUTATE_ORIGINS", result);
    });
    return ["customer/SET_ORIGINS", status];
  },
  async SET_COUNTRIES({ commit }) {
    let status = false;
    await apiCall.get("/api/rent/customers/countries", "", (result) => {
      if (result.error || result.errorCode) {
        status = false;
        return ["ORMgeneral/SET_COUNTRIES", status];
      } else {
        status = true;
      }
      commit("MUTATE_COUNTRIES", result);
    });
    return ["customer/SET_COUNTRIES", status];
  },
  async SET_SALUTATIONS({ commit }) {
    let status = false;
    await apiCall.get("/api/rent/customers/salutations", "", (result) => {
      if (result.error || result.errorCode) {
        status = false;
        return ["ORMgeneral/SET_SALUTATIONS", status];
      } else {
        status = true;
      }
      commit("MUTATE_SALUTATIONS", result);
    });
    return ["customer/SET_SALUTATIONS", status];
  },
  // eslint-disable-next-line
  async AUTHENTICATE({ commit }, credentials) {
    let status = false;
    // console.log(credentials);
    await apiCall.postHeaders(
        "/api/rent/customers/authenticate",
        credentials,
        (result) => {
          console.log(result.status);
          if (
              result.status == 201 ||
              result.status == 200 ||
              result.status == 204
          ) {
            status = true;
            store.dispatch("userSession/SET_LOGGEDINSESSION", result.data.token);
          } else {
            status = false;
          }
        }
    );
    return status;
  },
  // eslint-disable-next-line
  async FORGOTPASSWORD({ commit }, credentials) {
    let status = false;
    // console.log(credentials);
    await apiCall.putHeaders(
        "/api/rent/customers/authenticate/password/forgot",
        credentials,
        (result) => {
          console.log(result.status);
          if (result.status == 205 || result.status == 204) {
            status = true;
          // store.dispatch("userSession/SET_LOGGEDINSESSION", result.data.token);
          } else {
            status = false;
          }
        }
    );
    return status;
  },
  // eslint-disable-next-line
  async CHANGEPASSWORD({ commit }, credentials) {
    let status = false;
    // console.log(credentials);
    await apiCall.putHeaders(
        "/api/rent/customers/password",
        credentials,
        (result) => {
          console.log(result.status);
          if (result.status == 205 || result.status == 204) {
            status = true;
          // store.dispatch("userSession/SET_LOGGEDINSESSION", result.data.token);
          } else {
            status = false;
          }
        }
    );
    return status;
  },

  // eslint-disable-next-line
  async ACTIVATE({ commit }, credentials) {
    let status = false;
    await apiCall.putHeaders(
        "/api/rent/customers/authenticate/activate",
        credentials,
        (result) => {
          if (
              result.status == 201 ||
              result.status == 200 ||
              result.status == 204 ||
              result.status == 205
          ) {
            status = true;
          } else {
            console.log("active false");
            status = false;
          }
        }
    );
    return status;
  },
  // eslint-disable-next-line
  async GET_USER_DATA({ commit }) {
    let response = false;
    await apiCall.getHeaders("/api/rent/customers/me", "", (result) => {
      if (result.status == 401) {
        store.dispatch("userSession/LOGOUT");
      }
      if (
          result.status == 201 ||
          result.status == 200 ||
          result.status == 204
      ) {
        // console.log(result);
        response = result.data;
        commit("MUTATE_USER_DATA", result.data);
      }
    });

    return response;
  },
  async GET_BOOKINGS() {
    let response = false;
    await apiCall.getHeaders("/api/rent/customers/bookings", "", (result) => {
      if (
          result.status == 201 ||
          result.status == 200 ||
          result.status == 204
      ) {
        const bookings = [];
        for (const key in result.data) {
          const element = result.data[key];
          for (const key in element) {
            bookings.push(element[key]);
          }
        }
        response = result.data;
      }
    });

    return response;
  },
  // eslint-disable-next-line
  async ADD_MILEAGE({ commit }, {bookingId, payload}) {
    let response = "";

    await apiCall.postHeaders(`/api/rent/customers/bookings/${bookingId}/mileages`, payload, (result) => {
      response = { status: result.status, data: result.data };
    });
    return response;
  },
  // eslint-disable-next-line
  async SEND_CONTACT({ commit }, payload) {
    let response = "";

    await apiCall.postHeaders("/api/rent/contacts", payload, (result) => {
      response = { status: result.status, data: result.data };
    });
    return response;
    // return ["customer/SET_SALUTATIONS", status];
  },
  // eslint-disable-next-line
  async CHECK_EMAIL_EXCISTS({ commit }, payload) {
    let response = "";

    await apiCall.postHeaders(
        "/api/rent/customers/check_login",
        { email: payload },
        (result) => {
          response = { status: result.status, data: result.data };
        }
    );
    return response;
  },
  async CHECK_PASSWORD_STRENGTH({ commit }, payload) {
    let response = "";

    await apiCall.postHeaders(
        "/api/rent/customers/check_password",
        { password: payload },
        (result) => {
          if (result.status == 404) {
            response = { status: result.status, data: {
                valid: true, errors: []
              } };
          } else {
            response = {status: result.status, data: result.data};
          }
        }
    );
    return response;
  },
  DELETE_LOGIN_CUSTOMER({ commit }) {
    commit("MUTATE_DELETE_LOGIN_CUSTOMER");
  },
  // NEUE ACTION FÜR STORNIERUNG
  async CANCEL_BOOKING({ commit }, bookingId) {
    return new Promise((resolve, reject) => {
      apiCall.deleteHeaders(
          `/api/rent/customers/bookings/${bookingId}`,
          "",
          (result) => {
            if (
                result.status === 204 ||
                result.status === 200 ||
                result.status === 205
            ) {
              resolve({ status: result.status });
            } else {
              reject(result);
            }
          }
      );
    });
  },
};
const mutations = {
  MUTATE_MANDATORY_FIELDS(state, fields) {
    state.mandatoryFields = fields;
    sessionStorage.setItem(ENV + "mandatoryFields", JSON.stringify(fields));
  },
  MUTATE_COUNTRIES(state, countries) {
    state.countries = countries;
  },
  MUTATE_ORIGINS(state, origins) {
    state.origins = origins;
  },
  MUTATE_SALUTATIONS(state, salutations) {
    state.salutations = salutations;
    sessionStorage.setItem(
        ENV + "selectedSalutations",
        JSON.stringify(salutations)
    );
  },
  MUTATE_USER_DATA(state, userdata) {
    let salutation = "1";
    if (userdata.salutation) {
      salutation =
          Object.keys(userdata.salutation).length >= 0
              ? userdata.salutation.id
              : "1";
    }
    state.customer.customer = {
      id: userdata.id,
      salutation_id: salutation,
      email: userdata.email,
      firstname: userdata.firstname,
      lastname: userdata.lastname,
      name1: userdata.name1,
      company_name: userdata.company_name,
      street: userdata.street,
      zipcode: userdata.zipcode,
      city: userdata.city,
      country_id: userdata.country_id,
      phone_number: userdata.phone_number,
      allow_marketing: userdata.allow_marketing,
      drivers_license_number: userdata.drivers_license_number,
      drivers_license_date: userdata.drivers_license_date ? new Date(userdata.drivers_license_date) : null,
      drivers_license_city: userdata.drivers_license_city,
      create_login: false,
      birth_date: userdata.birth_date,
      mobile_phone: userdata.mobile_phone,
      invoice_receiver: userdata.invoice_receiver || null,
      payment_method: userdata.payment_method || null,
      mandatory_fields: userdata.mandatory_fields || {},
    };

    sessionStorage.setItem(
        ENV + "selectedCustomer",
        JSON.stringify(state.customer)
    );
  },
  MUTATE_DELETE_LOGIN_CUSTOMER(state) {
    state.customer = {
      customer: {
        salutation_id: "",
        email: "",
        firstname: "",
        lastname: "",
        company_name: "",
        street: "",
        zipcode: "",
        city: "",
        country_id: "",
        phone_number: "",
        allow_marketing: false,
        create_login: false,
        mandatory_fields: {},
      },
      payment_method_id: "",
      remarks: "",
    };

    sessionStorage.removeItem(ENV + "selectedCustomer");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};